module.exports = require('events').EventEmitter;



// WEBPACK FOOTER //
// ./~/stream-http/~/readable-stream/lib/internal/streams/stream-browser.js